import { initSmartDevicesSlider } from './pro-multifamily-overview-devices/pro-multifamily-overview-devices';
import { initIntegrationsSlider } from './pro-multifamily-overview-integrations/pro-multifamily-overview-integrations';
import { initCustomersSlider } from './pro-multifamily-overview-customers/pro-multifamily-overview-customers';
import { initSolutionsSlider } from './pro-multifamily-overview-solutions/pro-multifamily-overview-solutions';
import { runProPagesSmartSubnav } from '../../snippets/pro-pages-smart-subnav/pro-pages-smart-subnav';

window.onReady(() => {
  runProPagesSmartSubnav({
    intersectionThreshold: [0, 0.3],
    intersectionRatio: 0.3,
  });
  initSolutionsSlider();
  initSmartDevicesSlider();
  initIntegrationsSlider();
  initCustomersSlider();
});
